// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-horizontal-stepper-header-container {
  display: none !important;
}

::ng-deep .mat-horizontal-content-container {
  padding: 0 !important;
}

::ng-deep .mat-form-field-empty.mat-form-field-label,
.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  text-align: right;
}

::ng-deep .mat-form-field-appearance-fill .mat-form-field-infix {
  text-align: right;
}

.logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 125px;
}

.img-logo {
  object-fit: cover;
  width: 100%;
}

::ng-deep .mat-horizontal-content-container {
  border-radius: 16px;
}
::ng-deep .mat-form-field-flex {
  flex-direction: row-reverse;
  align-items: center !important;
}
::ng-deep .mat-form-field-flex input {
  text-align: start;
  direction: rtl;
}

.grid-tile {
  background-color: rgb(241, 245, 249);
}
.grid-tile ::ng-deep mat-horizontal-stepper {
  border-radius: 16px;
  box-shadow: 0 1px 3px 0 #b4bac0;
}
.grid-tile .auth-com {
  width: 400px;
}
.grid-tile .auth-com .stepper-card {
  width: 100%;
}
.grid-tile .auth-com .stepper-card .logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 180px;
}
.grid-tile .auth-com .stepper-card .logo-section .img-logo {
  object-fit: cover;
  width: 100%;
}
.grid-tile .auth-com .stepper-card h3 {
  font-weight: bold;
  font-size: smaller;
}
.grid-tile .auth-com .stepper-card form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.grid-tile .auth-com .stepper-card form mat-card-header ::ng-deep .mat-card-header-text {
  width: 100%;
  display: flex;
  justify-content: center;
}
.grid-tile .auth-com .stepper-card form mat-card-header mat-card-header {
  font-weight: bold;
  padding-bottom: 10px;
}
.grid-tile .auth-com .stepper-card form .card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.grid-tile .auth-com .stepper-card form .card-content h3 {
  text-align: right;
}
.grid-tile .auth-com .stepper-card form .time-verify-code {
  display: flex;
  justify-content: center;
  direction: rtl;
  padding: 20px 10px;
  font-size: 16px;
}
.grid-tile .auth-com .stepper-card form .time-verify-code > .finger-cursor span {
  cursor: pointer;
}
.grid-tile .auth-com .stepper-card form .time-verify-code > a {
  color: black;
  cursor: pointer;
}
.grid-tile .auth-com .stepper-card form span {
  padding: 5px 10px;
  border-radius: 10px;
  background-color: rgb(241, 245, 249);
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;
}
.grid-tile .auth-com .stepper-card form mat-card-actions {
  width: 100%;
  display: flex;
}
.grid-tile .auth-com .stepper-card form mat-card-actions button {
  width: 100%;
  border-radius: 10px;
}

.font-button {
  font-size: 14px;
}

.font-button {
  font-size: 16px;
}

.title-header {
  margin-bottom: 20px;
}

@media (max-width: 576px) {
  .grid-tile .auth-com {
    width: 90vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/auth/auth.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/auth/auth.component.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;ACDF;;ADIA;EACE,qBAAA;ACDF;;ADIA;;EAEE,iBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;ACDF;;ADIA;EACE,iBAAA;EACA,WAAA;ACDF;;ADKE;EACE,mBAAA;ACFJ;ADIE;EACE,2BAAA;EACA,8BAAA;ACFJ;ADGI;EACE,iBAAA;EACA,cAAA;ACDN;;ADMA;EAEE,oCAAA;ACJF;ADMI;EACE,mBAAA;EACA,+BAAA;ACJN;ADOE;EACE,YAAA;ACLJ;ADMI;EACE,WAAA;ACJN;ADKM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;ACHR;ADIQ;EACE,iBAAA;EACA,WAAA;ACFV;ADKM;EACE,iBAAA;EACA,kBAAA;ACHR;ADKM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;ACHR;ADMY;EACE,WAAA;EACA,aAAA;EACA,uBAAA;ACJd;ADOU;EACE,iBAAA;EACA,oBAAA;ACLZ;ADQQ;EAIE,aAAA;EACA,sBAAA;EACA,WAAA;ACTV;ADIU;EACE,iBAAA;ACFZ;ADQQ;EACE,aAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;ACNV;ADOU;EACE,eAAA;ACLZ;ADOU;EACE,YAAA;EACA,eAAA;ACLZ;ADQQ;EACE,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,uHAAA;ACNV;ADSQ;EACE,WAAA;EACA,aAAA;ACPV;ADQU;EACE,WAAA;EACA,mBAAA;ACNZ;;ADcA;EACE,eAAA;ACXF;;ADcA;EACE,eAAA;ACXF;;ADaA;EACE,mBAAA;ACVF;;ADYA;EAEI;IACE,WAAA;ECVJ;AACF","sourcesContent":["@import \"src/assets/styles/_breakpoints\";\r\n\r\n::ng-deep .mat-horizontal-stepper-header-container {\r\n  display: none !important;\r\n}\r\n\r\n::ng-deep .mat-horizontal-content-container {\r\n  padding: 0 !important;\r\n}\r\n\r\n::ng-deep .mat-form-field-empty.mat-form-field-label,\r\n.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n  text-align: right;\r\n}\r\n\r\n::ng-deep .mat-form-field-appearance-fill .mat-form-field-infix {\r\n  text-align: right;\r\n}\r\n\r\n.logo-section {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 150px;\r\n  width: 125px;\r\n}\r\n\r\n.img-logo {\r\n  object-fit: cover;\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep {\r\n  .mat-horizontal-content-container {\r\n    border-radius: 16px;\r\n  }\r\n  .mat-form-field-flex {\r\n    flex-direction: row-reverse;\r\n    align-items: center !important;\r\n    input {\r\n      text-align: start;\r\n      direction: rtl;\r\n    }\r\n  }\r\n}\r\n\r\n.grid-tile {\r\n  // background-color: skyblue;\r\n  background-color: rgb(241, 245, 249);\r\n  ::ng-deep {\r\n    mat-horizontal-stepper {\r\n      border-radius: 16px;\r\n      box-shadow: 0 1px 3px 0 #b4bac0;\r\n    }\r\n  }\r\n  .auth-com {\r\n    width: 400px;\r\n    .stepper-card {\r\n      width: 100%;\r\n      .logo-section {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        height: 300px;\r\n        width: 180px;\r\n        .img-logo {\r\n          object-fit: cover;\r\n          width: 100%;\r\n        }\r\n      }\r\n      h3 {\r\n        font-weight: bold;\r\n        font-size: smaller;\r\n      }\r\n      form {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        width: 100%;\r\n        mat-card-header {\r\n          ::ng-deep {\r\n            .mat-card-header-text {\r\n              width: 100%;\r\n              display: flex;\r\n              justify-content: center;\r\n            }\r\n          }\r\n          mat-card-header {\r\n            font-weight: bold;\r\n            padding-bottom: 10px;\r\n          }\r\n        }\r\n        .card-content {\r\n          h3 {\r\n            text-align: right;\r\n          }\r\n          display: flex;\r\n          flex-direction: column;\r\n          width: 100%;\r\n        }\r\n        .time-verify-code {\r\n          display: flex;\r\n          justify-content: center;\r\n          direction: rtl;\r\n          padding: 20px 10px;\r\n          font-size: 16px;\r\n          > .finger-cursor span {\r\n            cursor: pointer;\r\n          }\r\n          > a {\r\n            color: black;\r\n            cursor: pointer;\r\n          }\r\n        }\r\n        span {\r\n          padding: 5px 10px;\r\n          border-radius: 10px;\r\n          background-color: rgb(241 245 249);\r\n          box-shadow: rgb(0 0 0 / 20%) 0 2px 1px -1px,\r\n            rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;\r\n        }\r\n        mat-card-actions {\r\n          width: 100%;\r\n          display: flex;\r\n          button {\r\n            width: 100%;\r\n            border-radius: 10px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.font-button {\r\n  font-size: 14px;\r\n}\r\n\r\n.font-button {\r\n  font-size: 16px;\r\n}\r\n.title-header{\r\n  margin-bottom: 20px;\r\n}\r\n@media (max-width: 576px) {\r\n  .grid-tile {\r\n    .auth-com {\r\n      width: 90vw;\r\n    }\r\n  }\r\n}\r\n\r\n","::ng-deep .mat-horizontal-stepper-header-container {\n  display: none !important;\n}\n\n::ng-deep .mat-horizontal-content-container {\n  padding: 0 !important;\n}\n\n::ng-deep .mat-form-field-empty.mat-form-field-label,\n.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\n  text-align: right;\n}\n\n::ng-deep .mat-form-field-appearance-fill .mat-form-field-infix {\n  text-align: right;\n}\n\n.logo-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 150px;\n  width: 125px;\n}\n\n.img-logo {\n  object-fit: cover;\n  width: 100%;\n}\n\n::ng-deep .mat-horizontal-content-container {\n  border-radius: 16px;\n}\n::ng-deep .mat-form-field-flex {\n  flex-direction: row-reverse;\n  align-items: center !important;\n}\n::ng-deep .mat-form-field-flex input {\n  text-align: start;\n  direction: rtl;\n}\n\n.grid-tile {\n  background-color: rgb(241, 245, 249);\n}\n.grid-tile ::ng-deep mat-horizontal-stepper {\n  border-radius: 16px;\n  box-shadow: 0 1px 3px 0 #b4bac0;\n}\n.grid-tile .auth-com {\n  width: 400px;\n}\n.grid-tile .auth-com .stepper-card {\n  width: 100%;\n}\n.grid-tile .auth-com .stepper-card .logo-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  width: 180px;\n}\n.grid-tile .auth-com .stepper-card .logo-section .img-logo {\n  object-fit: cover;\n  width: 100%;\n}\n.grid-tile .auth-com .stepper-card h3 {\n  font-weight: bold;\n  font-size: smaller;\n}\n.grid-tile .auth-com .stepper-card form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.grid-tile .auth-com .stepper-card form mat-card-header ::ng-deep .mat-card-header-text {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.grid-tile .auth-com .stepper-card form mat-card-header mat-card-header {\n  font-weight: bold;\n  padding-bottom: 10px;\n}\n.grid-tile .auth-com .stepper-card form .card-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.grid-tile .auth-com .stepper-card form .card-content h3 {\n  text-align: right;\n}\n.grid-tile .auth-com .stepper-card form .time-verify-code {\n  display: flex;\n  justify-content: center;\n  direction: rtl;\n  padding: 20px 10px;\n  font-size: 16px;\n}\n.grid-tile .auth-com .stepper-card form .time-verify-code > .finger-cursor span {\n  cursor: pointer;\n}\n.grid-tile .auth-com .stepper-card form .time-verify-code > a {\n  color: black;\n  cursor: pointer;\n}\n.grid-tile .auth-com .stepper-card form span {\n  padding: 5px 10px;\n  border-radius: 10px;\n  background-color: rgb(241, 245, 249);\n  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;\n}\n.grid-tile .auth-com .stepper-card form mat-card-actions {\n  width: 100%;\n  display: flex;\n}\n.grid-tile .auth-com .stepper-card form mat-card-actions button {\n  width: 100%;\n  border-radius: 10px;\n}\n\n.font-button {\n  font-size: 14px;\n}\n\n.font-button {\n  font-size: 16px;\n}\n\n.title-header {\n  margin-bottom: 20px;\n}\n\n@media (max-width: 576px) {\n  .grid-tile .auth-com {\n    width: 90vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
